import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "@mantine/core";
import { useMemo } from "react";
import { useGetOrganizationSettingsQuery, useUpdateEmailSettingMutation, useUpdateOrganizationIntakeFormMutation } from "../../graphql/graphql";
import { EmailSettingCard } from "../email-setting/EmailSettingCard";
import { OrganizationIntakeFormCard } from "../organization/OrganizationIntakeFormCard";
import { LoadingCards } from "../../shared/Loading/LoadingCards";
import { showErrorNotification, showSuccessNotification } from "../../shared/Notifications";
export const NotificationSettingsView = ({ opened }) => {
    const [{ data, fetching }] = useGetOrganizationSettingsQuery({
        pause: !opened
    });
    const [, updateEmailSetting] = useUpdateEmailSettingMutation();
    const [{ fetching: updateIntakeFormFetching }, updateOrganizationIntakeForm] = useUpdateOrganizationIntakeFormMutation();
    const intakeSettings = useMemo(() => {
        return data?.organizations?.organization?.settings?.intakeForm ?? null;
    }, [data]);
    const emailSettings = useMemo(() => {
        return data?.emailSettings?.emailSettings ?? [];
    }, [data]);
    const handleToggleEmailSetting = async (emailSettingId, isEnabled) => {
        await updateEmailSetting({
            input: {
                emailSettingId,
                isEnabled
            }
        })
            .then(() => {
            showSuccessNotification("Email Setting Updated");
        })
            .catch(() => {
            showErrorNotification("Failed to update email setting");
        });
    };
    const handleUserChange = async (emailSettingId, userIds) => {
        await updateEmailSetting({
            input: {
                emailSettingId,
                toUserCommonIds: userIds
            }
        })
            .then(() => {
            showSuccessNotification("Email Setting Updated");
        })
            .catch(() => {
            showErrorNotification("Failed to update email setting");
        });
    };
    const handleToggleIntakeForm = async (isActive, url) => {
        await updateOrganizationIntakeForm({
            input: {
                intakeForm: {
                    isActive,
                    url
                }
            }
        });
    };
    return (_jsxs(Stack, { gap: "md", pt: "md", children: [fetching && _jsx(LoadingCards, { numCards: 10 }), _jsx(OrganizationIntakeFormCard, { isActive: intakeSettings?.isActive ?? false, url: intakeSettings?.url ?? undefined, pending: updateIntakeFormFetching, onIntakeChange: handleToggleIntakeForm }), emailSettings.map((emailSetting) => emailSetting && (_jsx(EmailSettingCard, { emailSettingId: emailSetting.emailSettingId, settingName: emailSetting.emailSettingType, isEnabled: emailSetting.isEnabled, toUsers: emailSetting.toUsers ?? [], onToggle: handleToggleEmailSetting, onUserChange: handleUserChange }, emailSetting.emailSettingId)))] }));
};
